import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import dateUtils from 'helpers/dateUtils';
import Dialog from 'material-ui/Dialog';
import Error from 'pages/products/productAvailibity/Error';
import Form from 'pages/products/productAvailibity/Form';
import Loader from 'components/loading/Loader';
import RaisedButton from 'material-ui/RaisedButton';
import RenderDateTimeInputField from 'components/form/InputFields/RenderDateTimeInputField';
import RenderLocationInputField from 'components/form/InputFields/RenderLocationInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import Results from 'pages/products/productAvailibity/Results';
import categoryHelper from 'helpers/category';
import compose from 'recompose/compose';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { ActivateIcon } from 'assets/materialIcons/materialIcons';
import { connect } from 'react-redux';
import { fetchProductAvailabilty } from 'store/actions/products/productAvailibity';
import { getFormValues, reduxForm } from 'redux-form';

const StyledDescription = styled.p`
    font-size: 11px;
    padding: 0 0 15px 0;
    margin: 0 0 20px 0;
    border-bottom: 1px solid #c0c0c0;
`;

const StyledCategory = styled.div`
    padding: 0 0 10px 0;
`;

const StyledDialogFrame = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 325px;
    max-height: 536px;
    overflow: hidden;
`;

const StyledForm = styled.form`
    width: 100%;
`;

class ProductAvailability extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dialog: false,
            error: '',
            event: 'show-form',
            results: {},
        };

        this.category = categoryHelper.getCategoryType(props.product.category_id);

        this.formInputs = [];
        this.generateFormInputs();

        this.showError = 'show-error';
        this.showForm = 'show-form';
        this.showLoader = 'show-loader';
        this.showResults = 'show-results';
    }

    componentDidMount() {
        const values = {};

        utils.each(this.formInputs, function (input) {
            if (input.hasOwnProperty('value')) {
                values[input.label] = input.value;
            }
        });

        this.props.initialize(values);
    }

    generateFormInputs() {
        const { product } = this.props;
        const categoryId = product.category_id;

        let inputs = [
            {
                component: RenderDateTimeInputField,
                label: 'destination_arrival_date',
                name: 'destination_arrival_date',
                required: true,
                value: dateUtils.addDaysToDateTime(new Date(), 1),
            },
            {
                component: RenderDateTimeInputField,
                label: 'destination_departure_date',
                name: 'destination_departure_date',
                required: true,
                value: dateUtils.addDaysToDateTime(new Date(), 8),
            },
        ];

        switch (categoryId) {
            case categoryHelper.getCategoryParkingId():
                inputs.push(
                    {
                        component: RenderTextInputField,
                        label: 'number_of_persons',
                        name: 'number_of_persons',
                        required: true,
                        value: 2,
                    },
                );
                break;

            case categoryHelper.getCategoryTaxiId():
            case categoryHelper.getCategoryTransferId():
                inputs.push(
                    {
                        component: RenderLocationInputField,
                        label: 'origin_address',
                        name: 'origin_point_of_interest_id',
                        required: true,
                    },
                    {
                        component: RenderLocationInputField,
                        label: 'destination_address',
                        name: 'destination_point_of_interest_id',
                        required: true,
                    },
                );
                break;

            default:
                break;
        }

        this.formInputs = inputs;
        return;
    }

    handleDialogOpen = () => {
        this.setState({
            dialog: true,
        });
    };

    handleDialogClose = () => {
        this.setState({
            dialog: false,
        });
    };

    handleCheckAvailability = () => {
        const { formValues, product: { id } } = this.props;

        if (!utils.isEmpty(formValues)) {

            this.setState(() => {
                return {
                    event: this.showLoader,
                };
            }, () => {
                this.props.checkAvailability({
                    callback: (response) => {
                        let values = {};

                        if (response.hasOwnProperty('error')) {
                            values = {
                                error: response.error,
                                event: this.showError,
                            };
                        }

                        if (response.hasOwnProperty('success')) {
                            values = {
                                event: this.showResults,
                                results: response.success,
                            };
                        }

                        this.setState(() => {
                            return values;
                        });
                    },
                    formValues: formValues,
                    id: id,
                });
            });
        }
    };

    showActions = () => {
        const { translate, invalid } = this.props;
        const { event } = this.state;

        let actions = [
            <RaisedButton
                disabled={ event === this.showLoader }
                key='goBack_1'
                keyboardFocused={ true }
                label={ translate('actions.goBack') }
                onTouchTap={ this.handleDialogClose }
                style={ { marginRight: '20px' } }
            />,
            <RaisedButton
                backgroundColor={ theme.palette.primary1Color }
                disabled={ invalid }
                icon={ <ActivateIcon /> }
                key='ok_1'
                label={ translate('actions.show') }
                labelColor={ theme.palette.white }
                onTouchTap={ () => {
                    this.handleCheckAvailability();
                } }
            />,
        ];

        // Confirmation Actions
        if (event === this.showResults || event === this.showError) {
            actions = [
                <RaisedButton
                    key='goBack_2'
                    label={ translate('actions.goBack') }
                    onTouchTap={ () => {
                        this.setState({
                            event: this.showForm,
                            error: '',
                            results: {},
                        });
                    } }
                    style={ { marginRight: '20px' } }
                />,
                <RaisedButton
                    backgroundColor={ theme.palette.primary1Color }
                    icon={ <ActivateIcon /> }
                    key='ok_2'
                    keyboardFocused={ true }
                    label={ translate('actions.ok') }
                    labelColor={ theme.palette.white }
                    onTouchTap={ () => {
                        this.handleDialogClose();
                    } }
                />,
            ];
        }

        return actions;
    }

    render() {
        const { handleSubmit, product, translate } = this.props;
        const { error, event, results } = this.state;

        const actions = this.showActions();

        return (
            <span>
                <Button
                    icon={ <ActivateIcon color={ theme.palette.primary1Color }/> }
                    onClick={ this.handleDialogOpen }
                    title={ translate('resources.products.availability.button') }
                />

                <Dialog
                    actions={ actions }
                    actionsContainerStyle={ { padding: '0 24px 24px' } }
                    contentStyle={ { maxWidth: '700px' } }
                    modal={ true }
                    overlayStyle={ {
                        backgroundColor: 'rgba(237, 236, 236, 0.6)',
                    } }
                    onRequestClose={ this.handleDialogClose }
                    open={ this.state.dialog }
                    title={ translate('resources.products.availability.dialog.title') }
                >
                    <StyledDescription>
                        { translate('resources.products.availability.dialog.description') }
                    </StyledDescription>

                    <StyledDialogFrame>
                        { event === this.showForm &&
                            <StyledForm
                                onSubmit={ handleSubmit }
                            >
                                <StyledCategory>Category: { this.category }</StyledCategory>

                                <Form
                                    inputs={ this.formInputs }
                                    product={ product }
                                />
                            </StyledForm>
                        }

                        { event === this.showLoader &&
                            <Loader />
                        }

                        { event === this.showError &&
                            <Error message={ error } />
                        }

                        { event === this.showResults &&
                            <Results
                                results={ results }
                            />
                        }
                    </StyledDialogFrame>
                </Dialog>
            </span>
        );
    }
}

ProductAvailability.propTypes = {
    checkAvailability: PropTypes.func,
    formValues: PropTypes.object,
    initialize: PropTypes.func,
    invalid: PropTypes.bool,
    handleSubmit: PropTypes.func,
    product: PropTypes.shape({
        category_id: PropTypes.number,
        id: PropTypes.string,
    }).isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    return {
        formValues: getFormValues(props.form)(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        checkAvailability: (params) => {
            dispatch(fetchProductAvailabilty(params));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    reduxForm({
        keepDirtyOnReinitialize: true,
    }),
);

export default enhance(ProductAvailability);



// WEBPACK FOOTER //
// ./src/pages/products/productAvailibity/ProductAvailability.js